import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/gib_claim.svg")